/**
 * Note that array's will likely need a wild card pathing which would be supported by
 *    /^(?:[\w-]+|\*)(?:\.(?:[\w-]+|\*))*$/
 */
export const validDotPath = /^(?:[\w-]+)(?:\.(?:[\w-]+))*$/;
